<template>
    <div class="trans-holder">
        <div v-for="lang in $lang.all" :key="lang" class="form-group m-form__group row" :class="{'has-danger': form.errors.has(`${property}.${lang}`)}" v-if="$lang.isActive(lang)">
            <label class="col-lg-3 col-form-label">{{ controlLabel }}
                <span class="trans-label">{{lang}}</span>
            </label>
            <div class="col-md-9 input-trans">
                <slot>
                    <textarea type="text" class="form-control" :name="property" v-model="value[lang]" rows="5" />
                </slot>
                <span class="form-control-feedback" v-show="form.errors.has(`${property}.${lang}`)">
                    {{ form.errors.get(`${property}.${lang}`) }}
                </span>
            </div>
        </div>
    </div>
</template>
<style>
span.trans-label {
    color: red;
}

.trans-holder .m-form__group:last-child {
    padding-bottom: 15px;
}

.trans-holder .m-form__group:first-child {
    padding-top: 15px;
}
</style>
<script>
import dgs from 'lib/dotgetset/index';
export default {
    props: ['form', 'property', 'label'],
    computed: {
        controlLabel() {
            return this.label || this.property.split('.')[0].replace(/_id$/, '').split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
        },
        value: {
            get: function() {
                return dgs.getValue(this.property, this.form);
            },
            set: function(newValue) {
                dgs.setValue(this.property, this.form, newValue);
            }
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/form/TextareaTrans.vue